import { useContext, useEffect } from "react";
import { NameContext } from "../context/NameContext";
import KompassOverview from "../kits/ManifestKit/KompassOverview";
import { PaperBG } from "../kits";
import { HashLink } from "react-router-hash-link";
import { loadModelViewer } from "../utils/loadModelViewer";
import SeoHelmet from "../components/SeoHelmet";

function Hero({ className = "" }) {
  const {
    name,
    setName,
    setIsNameEntered,
  } = useContext(NameContext);

  useEffect(() => {
    loadModelViewer();
  }, []);

  return (
<>

    <SeoHelmet
      title="Denis Bitter – Software Architect & Full-Stack Engineering Instructor"
      description="React · Angular · Flutter · UI Engineering · System Architecture. Ich entwickle klare Systeme für Lernen, Web & App – durchdacht, echt, skalierbar. EdTech. Medien. Lösungen mit Haltung."
      url="https://www.denisbitter.de/"
      image="https://www.denisbitter.de/images/hero-og.jpg"
    />



    <PaperBG>


      {/* Hauptbereich */}
      <section className={`
        relative font-mono text-black px-0 text-center min-h-screen
        ${className}
      `}>
        <div className="relative z-0 max-w-2xl mx-auto flex flex-col items-center space-y-8">
          <img
            src={`${process.env.PUBLIC_URL}/images/denis.svg`}
            alt="Denis Bitter"
            className="w-full max-w-sm h-auto max-h-[250px] sm:max-h-[250px]"
          />
       
<h1 className="text-xl sm:text-2xl md:text-2xl font-light leading-snug tracking-tight">
  <span className="block sm:inline">
    <strong>Software Architect & Full-Stack Engineering Instructor</strong> <br />
     <strong>FullStack Entwickler</strong>
  </span>



  <br />
  <span className="text-sm block">React · Angular · Flutter · UI Engineering · System Architecture</span>

  <span className="text-xs text-gray-400 block mt-1">
    #Systemarchitektur #DigitaleBildung #FullStackEntwicklung
  </span>
</h1>


        
        </div>
        <div className="w-full flex justify-center mt-8">
          
          <HashLink smooth to="/about#kompass" scroll={el => el.scrollIntoView({ behavior: "smooth", block: "start" })}>
            <KompassOverview className="w-full max-w-4xl" 
            
            />       
               
          </HashLink>

        </div>
    <div className="max-w-2xl w-full mx-auto flex flex-col items-center justify-center">
                  <h2 className="sr-only">Werte</h2>
                  <p className="text-xs md:text-xs leading-relaxed text-center text-gray-800 font-mono">
                    Ich glaube an Systeme, die verständlich sind.
                    <br />
                    An Bildung, die bleibt. Und an Ideen, die nutzbar werden.
                    <br />
                    <br />
                    Wenn Kreativität, Technologie &amp; Haltung zusammenkommen, entsteht echte Wirkung.
                  </p>
      
              
                </div>

      </section>
     
            
       

    
    </PaperBG>
    </>
  );

}

export default Hero;
